// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../font/Roboto-Regular.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../font/Roboto-Light.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../../font/CenturyGothic.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../../public/images/button2.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../../public/images/button1.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@font-face {
  font-family: "Roboto-Regular";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("truetype");
}
@font-face {
  font-family: "Roboto-Light";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("truetype");
}
@font-face {
  font-family: "Century Gothic";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("truetype");
}
.content_calculator {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
@media screen and (max-width: 991px) {
  .content_calculator {
    margin-bottom: 50px;
    flex-direction: column;
  }
}
.content_calculator .modal_window[data-visible=true] {
  display: flex;
  justify-content: center;
  align-items: center;
}
.content_calculator .modal_window[data-visible=true] .content_modal_calc {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 250px;
  height: 100px;
  background-color: rgb(255, 255, 255);
  border-radius: 10px;
}
.content_calculator .slider_calculator {
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-basis: 50%;
}
.content_calculator .slider_calculator .btn {
  width: 50px;
  height: 50px;
  border: none;
  background: transparent;
}
.content_calculator .slider_calculator .btn svg {
  pointer-events: none;
}
.content_calculator .slider_calculator .target_select {
  position: absolute;
  z-index: 2;
  left: 0;
  right: 0;
  bottom: 7%;
  display: flex;
  justify-content: center;
  pointer-events: none;
}
.content_calculator .slider_calculator .target_select .select_content {
  padding: 10px;
  background: #284722;
  color: rgb(255, 255, 255);
  font-family: "Roboto-Light";
  font-size: inherit;
}
.content_calculator .slider_calculator .target_select .select_content .noselect {
  text-align: center;
  font-size: 17px;
}
.content_calculator .slider_calculator .target_select .select_content .name_select {
  text-align: center;
  font-family: "Roboto-Regular";
  font-size: 17px;
  font-weight: 600;
}
.content_calculator .slider_calculator img {
  width: 300px;
  height: auto;
  pointer-events: none;
}
.content_calculator .test_calculator {
  flex-basis: 50%;
}
.content_calculator .test_calculator h5 {
  text-align: center;
  font-family: "Roboto-Regular";
  font-size: 17px;
  font-weight: 600;
  line-height: 3rem;
}
.content_calculator .test_calculator .title_form_phone {
  color: rgb(50, 50, 50);
  text-align: center;
  font-family: "Roboto-Regular";
  font-size: 17px;
  font-weight: 600;
  line-height: 3rem;
}
.content_calculator .test_calculator .title_form_phone .color_phone {
  color: rgb(145, 182, 27);
}
.content_calculator .test_calculator form fieldset {
  text-align: center;
  border: none;
}
.content_calculator .test_calculator form fieldset .phone_control {
  max-width: 310px;
  height: 52px;
  padding: 0 25px;
  margin: 0 auto 20px auto;
  background-color: #f2f2f2;
  border: none;
  border-radius: 0;
  font-family: "Roboto-Light";
  font-style: italic;
  font-size: 0.9em;
  font-weight: 400;
  text-transform: uppercase;
}
.content_calculator .test_calculator .result_calc_test {
  text-align: center;
  color: rgb(50, 50, 50);
  font-family: "Roboto-Regular";
  font-weight: 600;
}
@media screen and (min-width: 1201px) {
  .content_calculator .test_calculator .result_calc_test {
    font-size: 2.4rem;
    line-height: 3;
  }
}
@media screen and (max-width: 1200px) {
  .content_calculator .test_calculator .result_calc_test {
    font-size: 2.4rem;
    line-height: 2;
  }
}
@media screen and (max-width: 767px) {
  .content_calculator .test_calculator .result_calc_test {
    font-size: 2.4rem;
    line-height: 3rem;
    padding: 0 20px;
  }
}
.content_calculator .test_calculator .result_calc_test .color_result_calc {
  color: rgb(145, 182, 27);
}
@media screen and (min-width: 1201px) {
  .content_calculator .test_calculator .result_calc_test .color_result_calc {
    font-size: 6rem;
    line-height: 3rem;
  }
}
@media screen and (max-width: 1200px) {
  .content_calculator .test_calculator .result_calc_test .color_result_calc {
    font-size: 3rem;
    line-height: 2;
  }
}
@media screen and (max-width: 767px) {
  .content_calculator .test_calculator .result_calc_test .color_result_calc {
    font-size: 2.8rem;
    line-height: 3rem;
  }
}
.content_calculator .test_calculator .result_calc_test .mounth_color {
  color: rgb(0, 0, 0);
  font-weight: 600;
}
@media screen and (min-width: 1201px) {
  .content_calculator .test_calculator .result_calc_test .mounth_color {
    font-size: 3.2rem;
    line-height: 3.5rem;
  }
}
@media screen and (max-width: 1200px) {
  .content_calculator .test_calculator .result_calc_test .mounth_color {
    font-size: 2.8rem;
    line-height: 3rem;
  }
}
@media screen and (max-width: 767px) {
  .content_calculator .test_calculator .result_calc_test .mounth_color {
    font-size: 2rem;
    line-height: 3rem;
  }
}
.content_calculator .test_calculator .option {
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  text-align: center;
  font-family: "Roboto-Regular";
  font-size: 1.25rem;
  font-weight: bold;
  padding: 25px 20px;
  color: rgb(127, 125, 128);
  cursor: pointer;
}
.content_calculator .test_calculator .option:nth-child(2) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.content_calculator .test_calculator .option:nth-child(odd) {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}`, "",{"version":3,"sources":["webpack://./styles/fonts.scss","webpack://./src/components/BlockIncomeCalculator/BlockIncomeCalculator.scss"],"names":[],"mappings":"AAAA;EACI,6BAAA;EACA,+DAAA;ACCJ;ADEA;EACI,2BAAA;EACA,+DAAA;ACAJ;ADGA;EACI,6BAAA;EACA,+DAAA;ACDJ;AATA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;AAWJ;AATI;EALJ;IAMQ,mBAAA;IACA,sBAAA;EAYN;AACF;AAVI;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;AAYR;AAVQ;EACI,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,sBAAA;EACA,YAAA;EACA,aAAA;EACA,oCAAA;EACA,mBAAA;AAYZ;AARI;EACI,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAUR;AARQ;EACI,WAAA;EACA,YAAA;EACA,YAAA;EACA,uBAAA;AAUZ;AARY;EACI,oBAAA;AAUhB;AANQ;EACI,kBAAA;EACA,UAAA;EACA,OAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,uBAAA;EACA,oBAAA;AAQZ;AANY;EACI,aAAA;EACA,mBAAA;EACA,yBAAA;EACA,2BAAA;EACA,kBAAA;AAQhB;AANgB;EACI,kBAAA;EACA,eAAA;AAQpB;AALgB;EACI,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;AAOpB;AADQ;EACI,YAAA;EACA,YAAA;EACA,oBAAA;AAGZ;AACI;EACI,eAAA;AACR;AACQ;EACI,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AACZ;AAEQ;EACI,sBAAA;EACA,kBAAA;EACA,6BAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;AAAZ;AAEY;EACI,wBAAA;AAAhB;AAMY;EACI,kBAAA;EACA,YAAA;AAJhB;AAMgB;EACI,gBAAA;EACA,YAAA;EACA,eAAA;EACA,wBAAA;EACA,yBAAA;EACA,YAAA;EACA,gBAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,yBAAA;AAJpB;AASQ;EACI,kBAAA;EACA,sBAAA;EACA,6BAAA;EACA,gBAAA;AAPZ;AASY;EANJ;IAOQ,iBAAA;IAEA,cAAA;EAPd;AACF;AASY;EAZJ;IAaQ,iBAAA;IACA,cAAA;EANd;AACF;AAQY;EAjBJ;IAkBQ,iBAAA;IACA,iBAAA;IACA,eAAA;EALd;AACF;AAOY;EAGI,wBAAA;AAPhB;AASgB;EALJ;IAMQ,eAAA;IACA,iBAAA;EANlB;AACF;AAQgB;EAVJ;IAWQ,eAAA;IACA,cAAA;EALlB;AACF;AAOgB;EAfJ;IAgBQ,iBAAA;IACA,iBAAA;EAJlB;AACF;AAOY;EACI,mBAAA;EACA,gBAAA;AALhB;AASgB;EANJ;IAOQ,iBAAA;IACJ,mBAAA;EANd;AACF;AAQgB;EAXJ;IAYQ,iBAAA;IACA,iBAAA;EALlB;AACF;AAOgB;EAhBJ;IAiBQ,eAAA;IACA,iBAAA;EAJlB;AACF;AAQQ;EAEI,2BAAA;EACA,wBAAA;EACA,4BAAA;EACA,kBAAA;EACA,6BAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,eAAA;AAPZ;AAUQ;EACI,yDAAA;AARZ;AAWQ;EACI,yDAAA;AATZ","sourcesContent":["@font-face {\n    font-family: \"Roboto-Regular\"; \n    src: url(\"../font/Roboto-Regular.ttf\") format(\"truetype\");  \n}\n\n@font-face {\n    font-family: \"Roboto-Light\"; \n    src: url(\"../font/Roboto-Light.ttf\") format(\"truetype\");  \n}\n\n@font-face {\n    font-family: \"Century Gothic\"; \n    src: url(\"../font/CenturyGothic.ttf\") format(\"truetype\");  \n}\n\n","@import '../../../styles/fonts.scss';\n\n.content_calculator {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n\n    @media screen and (max-width: 991px) {\n        margin-bottom: 50px;\n        flex-direction: column;\n    }\n\n    .modal_window[data-visible=\"true\"] {\n        display: flex;\n        justify-content: center;\n        align-items: center;\n\n        .content_modal_calc {\n            display: flex;\n            justify-content: center;\n            align-items: center;\n            flex-direction: column;\n            width: 250px;\n            height: 100px;\n            background-color: rgb(255, 255, 255);\n            border-radius: 10px;\n        }\n    }\n\n    .slider_calculator {\n        position: relative;\n        display: flex;\n        flex-direction: row;\n        justify-content: center;\n        align-items: center;\n        flex-basis: 50%;\n\n        .btn {\n            width: 50px;\n            height: 50px;\n            border: none;\n            background: transparent;\n\n            svg {\n                pointer-events: none;\n            }\n        }\n\n        .target_select {\n            position: absolute;\n            z-index: 2;\n            left: 0;\n            right: 0;\n            bottom: 7%;\n            display: flex;\n            justify-content: center;\n            pointer-events: none;\n\n            .select_content {\n                padding: 10px;\n                background: #284722;\n                color: rgb(255, 255, 255);\n                font-family: \"Roboto-Light\";\n                font-size: inherit;\n\n                .noselect {\n                    text-align: center;\n                    font-size: 17px;\n                }\n\n                .name_select {\n                    text-align: center;\n                    font-family: \"Roboto-Regular\";\n                    font-size: 17px;\n                    font-weight: 600;\n\n                }\n            }\n        }\n\n        img {\n            width: 300px;\n            height: auto;\n            pointer-events: none;\n        }\n    }\n\n    .test_calculator {\n        flex-basis: 50%;\n\n        h5 {\n            text-align: center;\n            font-family: \"Roboto-Regular\";\n            font-size: 17px;\n            font-weight: 600;\n            line-height: 3rem;\n        }\n\n        .title_form_phone {\n            color: rgb(50, 50, 50);\n            text-align: center;\n            font-family: \"Roboto-Regular\";\n            font-size: 17px;\n            font-weight: 600;\n            line-height: 3rem;\n\n            .color_phone {\n                color: rgb(145, 182, 27);\n            }\n        }\n\n        form {\n\n            fieldset {\n                text-align: center;\n                border: none;\n\n                .phone_control {\n                    max-width: 310px;\n                    height: 52px;\n                    padding: 0 25px;\n                    margin: 0 auto 20px auto;\n                    background-color: #f2f2f2;\n                    border: none;\n                    border-radius: 0;\n                    font-family: \"Roboto-Light\";\n                    font-style: italic;\n                    font-size: 0.9em;\n                    font-weight: 400;\n                    text-transform: uppercase;\n                }\n            }\n        }\n\n        .result_calc_test {\n            text-align: center;\n            color: rgb(50, 50, 50);\n            font-family: \"Roboto-Regular\";\n            font-weight: 600;\n\n            @media screen and (min-width: 1201px) {\n                font-size: 2.4rem;\n                // line-height: 3rem;\n                line-height: 3;\n            }\n\n            @media screen and (max-width: 1200px) {\n                font-size: 2.4rem;\n                line-height: 2;\n            }\n\n            @media screen and (max-width: 767px) {\n                font-size: 2.4rem;\n                line-height: 3rem;\n                padding: 0 20px;\n            }\n\n            .color_result_calc {\n                // font-size: 6rem;\n                // line-height: 3.5rem;\n                color: rgb(145, 182, 27);\n\n                @media screen and (min-width: 1201px) {\n                    font-size: 6rem;\n                    line-height: 3rem;\n                }\n    \n                @media screen and (max-width: 1200px) {\n                    font-size: 3rem;\n                    line-height: 2;\n                }\n\n                @media screen and (max-width: 767px) {\n                    font-size: 2.8rem;\n                    line-height: 3rem;\n                }\n            }\n\n            .mounth_color {\n                color: rgb(0, 0, 0);\n                font-weight: 600;\n                // font-size: 3.2rem;\n                // line-height: 3.5rem;\n\n                @media screen and (min-width: 1201px) {\n                    font-size: 3.2rem;\n                line-height: 3.5rem;\n                }\n    \n                @media screen and (max-width: 1200px) {\n                    font-size: 2.8rem;\n                    line-height: 3rem;\n                }\n\n                @media screen and (max-width: 767px) {\n                    font-size: 2rem;\n                    line-height: 3rem;\n                }\n            }\n        }\n\n        .option {\n\n            background-position: center;\n            background-size: contain;\n            background-repeat: no-repeat;\n            text-align: center;\n            font-family: \"Roboto-Regular\";\n            font-size: 1.25rem;\n            font-weight: bold;\n            padding: 25px 20px;\n            color: rgb(127, 125, 128);\n            cursor: pointer;\n        }\n\n        .option:nth-child(2) {\n            background-image: url('../../../public/images/button2.png');\n        }\n\n        .option:nth-child(odd) {\n            background-image: url('../../../public/images/button1.png');\n        }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
